<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_1"></h2>
<div style="text-align:center;"><img alt="9780830897056.jpg" src="Images/9780830897056.jpeg" style="max-width:100%;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?1c114d0f